import { useQuery, useMutation } from 'react-query';
import { AxiosResponse, AxiosError } from 'axios';
import type { TSendMtanPayload, TSendMtanResp, TMtanTerminationPayload } from './types';
import { sendMtan, mtanTermination } from './request';
import type { TMutation } from '../types';

export const useSendMtan = ({
    body,
    refetchOnMount = true,
    enabled = true,
    onSuccess,
    onError,
}: {
    body: TSendMtanPayload,
    refetchOnMount?: boolean,
    enabled?: boolean
    onSuccess?: (resp: TSendMtanResp) => void,
    onError?: () => void,
}) => {
    const query = useQuery<
        TSendMtanResp,
        null | { message: string },
        TSendMtanResp
    >({
        queryFn: () => sendMtan(body).then(({ data }) => data),
        refetchOnWindowFocus: false,
        refetchOnMount,
        enabled,
        onSuccess: (resp) => {
            if (onSuccess) {
                onSuccess(resp);
            }
        },
        onError: () => {
            if (onError) {
                onError();
            }
        },
    });

    return query;
};

export const mutationMtanTermination = ({
    onSuccess,
    onError,
}: TMutation<any>) => useMutation<
    AxiosResponse<any>,
    AxiosError,
    TMtanTerminationPayload
>({
    mutationFn: mtanTermination,
    onSuccess: (resp) => {
        if (onSuccess) {
            onSuccess(resp.data);
        }
    },
    onError: () => {
        if (onError) {
            onError();
        }
    },
});
